import { buttonFor, type InputKind, type PadButton } from "./input-names";

/** A card button's shortcut on the input you're using, "(✕)" or "(Space)"; none on glass, where you tap it (#147). */
export function KeyHint({ input, button }: { input: InputKind; button: PadButton }) {
  return input === "touch" ? null : <span className="text-xs not-italic opacity-70">({buttonFor(input, button)})</span>;
}
